export default __webpack_public_path__ + "static/media/python.439dd3d2.svg";